import { AsyncNamespace, defineEvent, EventTopic, otto } from "@otto-ec/global-resources/nexus";

export interface Page {
  sortiertnach?: string;
  l?: string;
  o?: string;
}

export interface FilterSectionLoadEvent {
  rule: string;
  page: Page;
  ssid?: string;
}

export interface FilterSectionInitialLoadedEvent {
  response: Response;
  rule: string;
}

export interface FacetValueTagsLoadedEvent {
  rule: string;
  tags: string[];
}

export interface FilterPersonalizationSaveEvent {
  values: string[];
}

export interface FilterPersonalizationDeleteEvent {
  values: string[];
}

export interface FilterPersonalizationTrackEvent {
  action: "save" | "delete" | "delete_all" | "undo_delete";
  facetId: string;
  values: string[];
  remainingSavedValues?: string[]; /*                                                             */
}

export interface FilterSectionChangeEvent {
  target: EventTarget;
}

export type HeurekaEvents = {
  filterSection_load: EventTopic<FilterSectionLoadEvent>;
  filterSection_loaded: EventTopic<{}>;
  filterSection_initialLoaded: EventTopic<FilterSectionInitialLoadedEvent>;
  filterSection_loadAborted: EventTopic<{}>;
  facetValueTags_loaded: EventTopic<FacetValueTagsLoadedEvent>;
  filterVisibilities_load: EventTopic<FilterSectionLoadEvent>;

  filterPersonalization_save: EventTopic<FilterPersonalizationSaveEvent>;
  filterPersonalization_saved: EventTopic<[]>;
  filterPersonalization_delete: EventTopic<FilterPersonalizationDeleteEvent>;
  filterPersonalization_deleted: EventTopic<[]>;
  filterPersonalization_track: EventTopic<FilterPersonalizationTrackEvent>;
  filterPersonalizationBanner_loaded: EventTopic<{}>;
  refinementBar_loaded: EventTopic<{}>;
  refinementBar_update: EventTopic<[]>;
  nextBestAction_loaded: EventTopic<[]>;

  filterSection_change: EventTopic<FilterSectionChangeEvent>;

  sliders_initialized: EventTopic<{}>;
}

declare global {
  interface NexusInterfaces {
    heureka: AsyncNamespace<HeurekaEvents>;
  }
}

otto.heureka.assignNamespace({
  filterSection_load: defineEvent(),
  filterSection_loaded: defineEvent(),
  filterSection_initialLoaded: defineEvent(),
  filterSection_loadAborted: defineEvent(),
  facetValueTags_loaded: defineEvent(),
  filterVisibilities_load: defineEvent(),

  filterPersonalization_save: defineEvent(),
  filterPersonalization_saved: defineEvent(),
  filterPersonalization_delete: defineEvent(),
  filterPersonalization_deleted: defineEvent(),
  filterPersonalization_track: defineEvent(),
  filterPersonalizationBanner_loaded: defineEvent(),

  filterSection_change: defineEvent(),

  refinementBar_loaded: defineEvent(),
  nextBestAction_loaded: defineEvent(),

  sliders_initialized: defineEvent(),
});

export const heureka : HeurekaEvents = otto.heureka;
